export const RenewMembershipPage = () => {

	return (
		<div>
			you are already a member with venue name, please go to the reception to update your membership
		</div>
	)
}
